import { useCallback, useState } from 'react';

import type { UseUploadResult } from '../use-upload';
import { useUpload } from '../use-upload';

type UseDocumentsUploadValue = {
  uploads: UseUploadResult['uploads'];
  handleDeleteUpload: UseUploadResult['handleDeleteUpload'];
  handleUploadFile: UseUploadResult['handleUploadFile'];
  showUploadInProgressError: boolean;
  isUploading: boolean;
  setShowUploadInProgressError: (isUploadingInProgress: boolean) => void;
};

export const useDocumentsUpload = (): UseDocumentsUploadValue => {
  const [showUploadInProgressError, setShowUploadInProgressError] =
    useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const onUploadStatusUpdate = useCallback((uploadingStatus: boolean): void => {
    setIsUploading(uploadingStatus);
    setShowUploadInProgressError(false);
  }, []);

  const { handleDeleteUpload, handleUploadFile, uploads } = useUpload({
    onUploadStatusUpdate,
  });

  return {
    uploads,
    handleDeleteUpload,
    handleUploadFile,
    isUploading,
    showUploadInProgressError,
    setShowUploadInProgressError,
  };
};
